import _ from 'lodash'
import { InventoriesAvailables as InventoriesAvailable } from 'types/common'

export const findInventoryById = (collection: InventoriesAvailable[], inventoryId: string | number) =>
    collection.find((item) => item.subscription_company_id === Number(inventoryId))

export function isUnlimitedInventory(collection: InventoriesAvailable[], inventoryType: string) {
    const findInventorySelected = _.find(collection, {'subscriptionName': inventoryType })
    return findInventorySelected?.subscriptionId === 3
}

export const parseInventoryNameToId = (collection: InventoriesAvailable[], inventoryName: string) => {
    const ID = collection.find((item: any) => item.subscriptionName === inventoryName)?.subscriptionId
    return ID
}

export const parseInventoryIdToName = (collection: InventoriesAvailable[], inventoryId: number) => {
    const NAME = collection.find((item: any) => item.subscription_company_id === inventoryId)?.subscriptionName
    return NAME
}

export const getSubcriptionCompanyId = (collection: InventoriesAvailable[], inventoryName: string) => {
    const ID = collection.find((item: any) => item.subscriptionName === inventoryName)?.subscription_company_id
    return ID
}
